
export default [
    {
        path: '/newCourse/list',
        name: 'newCourselist',
        component: () => import('../views/newCourse/list'),
        meta:{
            title:'选课学习',
            keep:true
        }
    },
    {
        path: '/newCourse/details',
        name: 'newCoursedetails',
        component: () => import('../views/newCourse/details'),
        meta:{
            title:'课程详情',
            keep:true
        }
    },
    {
        path: '/newCourse/video',
        name: 'newCoursevideo',
        component: () => import('../views/newCourse/video'),
        meta:{
            title:'课程播放'
        }
    },
    {
        path: '/newCourse/videoplay',
        name: 'videoplay',
        component: () => import('../views/newCourse/videoplay'),
        meta:{
            title:'课程播放'
        }
    },


]